// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import VueCookies from "vue-cookies";
import VueMeta from 'vue-meta'
import axios from 'axios'

import ElementUI from 'element-ui' //全局引入
import 'element-ui/lib/theme-chalk/index.css' //全局引入主题
//import { Button, Select } from 'element-ui' //按需引入（主题在babelrc配置）

Vue.config.productionTip = false;

Vue.use(VueCookies); //全局使用
Vue.use(VueMeta); //全局使用
Vue.use(ElementUI); //全局引入
Vue.prototype.$axios = axios; //将 axios 挂载到 Vue 实例原型上（全局this.$axios使用）
const chead = 'Astock'; //cookie信息命名头（自定义项目名）
Vue.prototype.$cookies_head = chead; //设置全局变量便于模板变更应用，一个顶级域名下的cookie名字不冲突，cookie默认命名规则：项目名%功能名#变量名

/**按需引入
Vue.use(Button);
Vue.use(Select);
*/


// 在顶部缓存 Vue 实例的上下文（此处不能直接使用this.$cookies.get，this 并不是指向 Vue 实例，而是拦截器函数自身的上下文。因此，在拦截器函数内部使用 this.$cookies 和 this.$axios 会导致上下文错误）
const vueInstance = new Vue();//引用了一个现有的 Vue 实例，而不是创建了新的实例。因此，这种做法不会增加额外的内存开销，也不会导致性能下降。
/*请求拦截器*/
axios.interceptors.request.use(
  function(config){
    const stoken = vueInstance.$cookies.get(chead+"%main#token");
    if(stoken != undefined){
      config.headers.common = config.headers.common || {};// 检查是否存在 config.headers.common，如果不存在就创建
      config.headers.common.Authorization = 'JWT ' + stoken;
      /**1.0版本以上axios请直接使用config.headers.Authorization = "JWT " + stoken; */
    }
    return config;
  },
  function(error){
    router.push('/login');
    return Promise.reject(error);
  }
);

/*响应拦截器*/
axios.interceptors.response.use(
  function(response){
    return response;
  },
  function(error){
    console.log(error);
    if(error.response.status==401){ alert("暂无访问权限，请登录！"); }
    else if(error.response.status==400){ console.log("账户密码不匹配...") }
    else{ alert("请求出错，请稍后再试!"); }
    return Promise.reject(error);
  }
);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  data: {
    cookies_head: 've',//默认项目名（初始化用）
  },
  components: { App },
  template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js